const totalCountByWeightAndZoneResponseToTotalCountByWeightAndZoneObject = (response) => {
    return {
        weight: response.weight,
        zone: response.zone,
        count: response.count
    };
};

export { totalCountByWeightAndZoneResponseToTotalCountByWeightAndZoneObject };